<template>
  <div class="ModifyBox">
		<div class="_modify">
			<p class="_label">修改密码</p>
			<div class="_cont">
				<div class="_form">
					<el-form :model="ruleForm"  :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
						<el-form-item label="用户名">
							<el-input :disabled="true" v-model="ruleForm.name"></el-input>
						</el-form-item>
						<el-form-item label="原密码" prop="oldpassword">
							<el-input  show-password v-model="ruleForm.oldpassword"></el-input>
						</el-form-item>
						<el-form-item label="新密码" prop="newpassword">
							<el-input show-password v-model="ruleForm.newpassword"></el-input>
						</el-form-item>
						<el-form-item label="重复新密码" prop="newpassword2">
							<el-input show-password v-model="ruleForm.newpassword2"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click.stop="submitForm('ruleForm')">提交</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import { request } from "../../css/request.js";
import { Apis } from "../../css/Api.js";
export default {
	name:"modify",
	props:{
		phone:{
      type: String,
      default: ''
    }
	},
	data(){
		// const validation = (rule, value, callback) => {
		// 	if(this.ruleForm.newpassword !== this.ruleForm.newpassword2){
		// 		callback(new Error('两次密码输入不相同'))
		// 	}
		// }
		return {
			ruleForm:{
				name:this.phone,
				oldpassword:'',
				newpassword:'',
				newpassword2:'',
			},
			rules:{
				// name:[
				// 	{ required: true, message: '请输入供应商名称', trigger: 'blur' },
				// ],
				oldpassword:[
					{ required: true, message: '请输入原密码', trigger: 'blur' },
				],
				newpassword:[
					{ required: true, message: '请输入新密码', trigger: 'blur' },
				],
				newpassword2:[
					{ required: true, message: '请重复输入新密码', trigger: 'blur' },
				]
			}
		}
	},
	methods:{
		submitForm(formName){
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (this.ruleForm.newpassword.length<6 || 
							this.ruleForm.newpassword.length>20 || 
							!(/[a-z]+/).test(this.ruleForm.newpassword) || 
							!(/[A-Z]+/).test(this.ruleForm.newpassword) || 
							!(/[0-9]+/).test(this.ruleForm.newpassword)
						) {
							this.$message({
							message: '您的密码复杂度太低（密码中必须包含大小写字母、数字,长度6-20位），请修改密码',
							showClose: true,
							duration:1500,
							type: 'warning'
						});
						return;
					}
					if(this.ruleForm.newpassword !== this.ruleForm.newpassword2){
						this.$message.error('两次新密码输入不相同');
						return;
					}else{
						this.setModify()
					}
					
				} else {
					return false;
				}
			});
		},
		setModify(){
			let access_token = localStorage.getItem('access_token')
			let data = {
				access_token:access_token,
				oldpwd:this.ruleForm.oldpassword,
				newpwd:this.ruleForm.newpassword,
				renewpwd:this.ruleForm.newpassword2,
			}
			request({
				method: "post", 
				url: Apis.updPassword,
				params:data
			}).then(res => {
				if(res.code == 0){
					this.$message({
						message: res.data,
						showClose: true,
						duration:1500,
						type: 'success'
					});
					this.$store.commit("access_token", null);
					localStorage.removeItem("access_token");
					this.$router.go(0)
					this.$router.push({ 
						path: '/'
					})
				}else{
					this.$message.error(res.msg);
				}
			});
		}
	}
}
</script>

<style lang="less" scoped>
.ModifyBox{
	width: 100%;
	._modify{
		width: 100%;
		min-height: 880px;
		background: #fff;
		padding: 40px;
		._cont{
			margin-top: 40px;
			._form{
				text-align: left;
				width: 51%;
				._textarea{
					resize: none;
					outline: none;
				}
			}
		}
	}
}
._label{
	// width: 140px;
	text-align: left;
	padding-left: 10px;
	position: relative;
	line-height: 30px;
	font-weight: bold;
	font-size: 20px;
	left: 10px;
}
._label::after{
	content: '';
	display: inline-block;
	width: 4px;
	height: 23px;
	background: #1F8EFF;
	position: absolute;
	top: 5px;
	left: 0px;
}
</style>
<style scoped>
.ModifyBox >>> .el-textarea__inner{
	resize: none;
	outline: none;
}
</style>